/**
 * Lista dei principali fornitori di energia elettrica e gas in Italia
 * Fonte: ARERA (Autorità di Regolazione per Energia Reti e Ambiente)
 * https://www.arera.it/area-operatori/ricerca-operatori
 *
 * NOTA: Hera Comm e' volutamente esclusa dalle liste perche' un cliente che
 * compila una proposta di vendita Hera Comm non puo' avere Hera Comm come
 * fornitore "precedente" (i casi switch / voltura riguardano per definizione
 * un fornitore diverso da Hera).
 */

// Fornitori di energia elettrica (vendita a clienti finali mercato libero)
export const FORNITORI_LUCE: string[] = [
  'Enel Energia',
  'Eni Plenitude',
  'Edison Energia',
  'A2A Energia',
  'Iren Mercato',
  'ACEA Energia',
  'Sorgenia',
  'E.ON Energia',
  'Engie Italia',
  'Illumia',
  'Dolomiti Energia',
  'Alperia',
  'Green Network',
  'Axpo Italia',
  'Wekiwi',
  'NeN',
  'Pulsee',
  'Optima Italia',
  'Fastweb Energy',
  'Duferco Energia',
  'CVA Energie',
  'Bluenergy Group',
  'Repower Italia',
  'Energit',
  'Estra Energie',
  'Metamer',
  'Enegan',
  'Vivigas',
  'Gas Natural Vendita Italia',
  'Audax Energia',
  'Sentra Energia',
  'Agsm AIM Energia',
  'Gelsia',
  'Enercom',
  'Unareti',
  'Ascopiave Energie',
  'Egea Commerciale',
  'Acciaierie Energia',
  'EP Produzione',
  'Holding Energia',
  'Convergenze',
  'Consorzio Energia Sardegna',
  'Energetic Spa',
  'Gasway',
  'Global Power',
  'Olimpia Energia',
  'Prometeo',
  'Sinergy Luce e Gas',
  'Tate Energia',
  'Tirreno Power',
  'Ubroker',
  'Utility Manager',
  'Veritas Energia',
  'Yada Energia',
  'Altro fornitore'
]

// Fornitori di gas naturale (vendita a clienti finali mercato libero)
export const FORNITORI_GAS: string[] = [
  'Eni Plenitude',
  'Enel Energia',
  'Edison Energia',
  'A2A Energia',
  'Iren Mercato',
  'ACEA Energia',
  'Sorgenia',
  'E.ON Energia',
  'Engie Italia',
  'Illumia',
  'Dolomiti Energia',
  'Alperia',
  'Green Network',
  'Wekiwi',
  'NeN',
  'Pulsee',
  'Optima Italia',
  'Duferco Energia',
  'Bluenergy Group',
  'Estra Energie',
  'Metamer',
  'Enegan',
  'Vivigas',
  'Gas Natural Vendita Italia',
  'Audax Energia',
  'Sentra Energia',
  'Agsm AIM Energia',
  'Gelsia',
  'Enercom',
  'Ascopiave Energie',
  'Egea Commerciale',
  'Energetic Spa',
  'Gasway',
  'Global Power',
  'Olimpia Energia',
  'Sinergy Luce e Gas',
  'Tate Energia',
  'Ubroker',
  'Utility Manager',
  'Veritas Energia',
  'Yada Energia',
  '2i Rete Gas',
  'Italgas',
  'Snam',
  'Altro fornitore'
]

// Lista unificata (per campi generici)
export const FORNITORI_ENERGIA: string[] = [
  ...new Set([...FORNITORI_LUCE, ...FORNITORI_GAS])
].sort((a, b) => {
  // "Altro fornitore" sempre in fondo
  if (a === 'Altro fornitore') return 1
  if (b === 'Altro fornitore') return -1
  return a.localeCompare(b, 'it')
})

